import { fileFormToUpdate, genderToStr, interestsToStr } from '@/_containers';
import { nullableStringToNullableIntConverter } from '@/_schemas/generic';
import { statusToStr } from '@/_schemas/status-input';

import { shirtSizePreferenceToStr, techPreferenceToStr } from '../components';
import type { TeamMemberFormSchema, TeamMemberUpdateSchema } from '../schemas';

export function teamMemberFormToUpdate({
  status,
  interests,
  profile_image,
  phone_numbers,
  parent,
  gender,
  tech_preference,
  t_shirt_size,
  preferred_relationship,
  emergency_contact,
  addresses,
  gallery,
  offer_letter,
  employment_agreement,
  handbook_acknowledgement,
  vector_signatured,
  business_card_template,
  gusto,
  freshdesk,
  harvest,
  zoom,
  lockdown_override_pin,
  ...rest
}: TeamMemberFormSchema): TeamMemberUpdateSchema {
  const payload = {
    ...rest,
    interests: interestsToStr(interests),
    phone_numbers: phone_numbers?.map((item) => item.id) ?? [],
    status: statusToStr(status),
    profile_image: fileFormToUpdate(profile_image),
    parent_id: parent?.id ?? null,

    gender: genderToStr(gender),
    tech_preference: techPreferenceToStr(tech_preference),
    t_shirt_size: shirtSizePreferenceToStr(t_shirt_size),

    preferred_relationship_id: preferred_relationship?.id ?? null,
    emergency_contact: emergency_contact?.map((item) => item.id) ?? [],
    addresses: addresses?.map((item) => item.id) ?? [],
    gallery: gallery?.map((item) => item.id) ?? [],
    offer_letter: offer_letter?.map((item) => item.id) ?? [],
    employment_agreement: employment_agreement?.map((item) => item.id) ?? [],
    handbook_acknowledgement: handbook_acknowledgement?.map((item) => item.id) ?? [],
    vector_signatured: vector_signatured?.map((item) => item.id) ?? [],
    business_card_template: business_card_template?.map((item) => item.id) ?? [],
    zoom: nullableStringToNullableIntConverter(zoom),
    freshdesk: nullableStringToNullableIntConverter(freshdesk),
    harvest: nullableStringToNullableIntConverter(harvest),
    gusto: gusto,
  } as TeamMemberUpdateSchema;

  // Only send PIN if user intentionally entered it.
  if (lockdown_override_pin && lockdown_override_pin.trim().length > 0) {
    return { ...payload, lockdown_override_pin };
  }

  return payload;
}
